import { BROWSER, DISNEY_ANDROID, DISNEY_IOS,DISNEY_HARMONYOS, MINI_PROGRAM, MOBILE, WECHAT } from '../platform/platform-detect';

export const funcTypeMap = new Map([
    ['phonePin', 'GUEST_LOGIN_MOBILE'],
    ['phonePwd', 'GUEST_LOGIN_MOBILE'],
    ['emailPwd', 'GUEST_LOGIN_EMAIL'],
    ['legacyPhonePin', 'GUEST_LOGIN_MOBILE'],
    ['cspPhonePin', 'GUEST_LOGIN_MOBILE'],
    ['forgetPwdEmail', 'FORGOT_PASSWORD_EMAIL'],
    ['forgetPwdPhone', 'FORGOT_PASSWORD_MOBILE'],
    ['deleteAcct', 'DELETE_ACCOUNT_MOBILE'],
    ['phoneUpdate', 'MOBILE_UPDATE']
]);

export const guestAgeType = new Map([
  ['STANDARD', 'ADULT'],
  ['CHILD', 'CHILD'],
  ['SENIOR', 'OLD']
]);

/**
 * 以下业务需要在profile特殊处理，在此处做统一管理
 * eg: MO,GR,PBP在web端不需要header和footer
 * eg: GPL跳转逻辑
 */
export const bussinessCodeMap = {
  'GR': 'Guest_Registration',
  'MO': 'Mobile_Order',
  'GPL': 'Parking',
  'PBP': 'Partnership',
}

// 由于gpl团队和神策团队就platform的传值未达成一致，导致profile h5需要做一次手动映射
// 将gpl小程序在url传的'mp_weixin_parking'，转为track.js文件中存在的映射'wechat_parking_mp'
export const wxTrackingMap = new Map([
  ['mp_weixin_parking', 'wechat_parking_mp']
]);

//cta-name for edit-profile my-center and my-setting
export const guestCtaName = new Map([
  ['change-avatar', 'change_character'],
  ['change-name', 'name'],
  ['region', 'country_region'],
  ['birth', 'date_of_birth'],
  ['setting', 'account_settings'],
  ['logout', 'sign_out'],
  ['change-phone-old', 'change_phone'],
  ['change-email', 'change_email'],
  ['add-pwd', 'set_password'],
  ['change-pwd', 'change_password'],
  ['delete-acct', 'delete_account']
]);

export const getPinCodeEntry = new Map([
  ['phonePin', 'login'],
  ['legacyPhonePin', 'legacy_phone_bind'],
  ['forgetPwdEmail', 'forgot_password_email'],
  ['forgetPwdPhone', 'forgot_password_phone'],
  ['deleteAcct', 'delete_account'],
  ['phoneUpdate', 'update_phone'],
  ['cspPhonePin','csp_phone_bind']
]);

export const platChannelCodeMap = new Map([
  [WECHAT, 'SHDR_WeChatOA'],
  [MINI_PROGRAM, 'SHDR_WeChatMP_Ecommerce'],
  [DISNEY_IOS, 'SHDR_APP_iOS'],
  [DISNEY_ANDROID, 'SHDR_APP_Android'],
  [DISNEY_HARMONYOS, 'SHDR_APP_HarmonyOS'],
  [MOBILE, 'SHDR_Website_Mobile'],
  [BROWSER, 'SHDR_Website_PC'],
]);

export const monthsMap = {
    'Jan': 1,
    'Feb': 2,
    'Mar': 3,
    'Apr': 4,
    'May': 5,
    'Jun': 6,
    'Jul': 7,
    'Aug': 8,
    'Sep': 9,
    'Oct': 10,
    'Nov': 11,
    'Dec': 12
}

// temporary public_key and private_key
export const tempPub = 'TUlHZk1BMEdDU3FHU0liM0RRRUJBUVVBQTRHTkFEQ0JpUUtCZ1FES0tIQ2dHL3BPcHRUTlZTOHhHWndGcjhYTjNFdmc3SWZ0RXpYMVkyWTE0YnNKWTdINHVUYjJFUUg2UkFYTnQ0b0JJaWdKMWdXV2VQZURqRy9ieWs2b1ROV3YreTJxK3JyQnlFU2l4UllXaUYxcyt4QmFhSHp5ZzBmUmlDM0pPelJKVVBwOXN6bStKVnhoeFlBRHM4cE83ak55T3JJcS9Wa0liT3diL3ZJWjh3SURBUUFC';
export const tempPri = 'TUlJQ2R3SUJBREFOQmdrcWhraUc5dzBCQVFFRkFBU0NBbUV3Z2dKZEFnRUFBb0dCQU1vb2NLQWIrazZtMU0xVkx6RVpuQVd2eGMzY1MrRHNoKzBUTmZWalpqWGh1d2xqc2ZpNU52WVJBZnBFQmMyM2lnRWlLQW5XQlpaNDk0T01iOXZLVHFoTTFhLzdMYXI2dXNISVJLTEZGaGFJWFd6N0VGcG9mUEtEUjlHSUxjazdORWxRK24yek9iNGxYR0hGZ0FPenlrN3VNM0k2c2lyOVdRaHM3QnYrOGhuekFnTUJBQUVDZ1lFQXY3NkZ2TWRzcmtjOUZwa1NqdDY4aHdSR2VORFh3N3AxM3A3WEVpNDZseWJJOGNuMjEzUk50aTFCay9BTEZTbGVJMThUWE9qOEdkSVk2bFE5RU5xZHFRRVNlMGx6dFNyM1lJdVcydFVhVm9HRStSOXg5N3JCUHhIa1o5NGp4RnNvd21yazhnRkpJTWViVGNFNFphQ3Q5MlozM0R4eGwwdTZJUjR6dDNRYmtIRUNRUUQ0NnhIbWdMMTdUSkNTdkIza3hYTzV2c05CMVdHbkthaVFrVzN0RVptU1M1UXVCNGFlNlNFNTVWOExoaHNveFBTM0EvOW4rUURTTkFMTFowcS8vci9aQWtFQXorak4wQVRLTjZJYURVVlFkRDYyN2cyV2QvWnF5T3g4MVczYWtmQ29URzkxQzFRMElmeTYrd3BEc3djblVIOHppdWJmVFpMenBRRWwxY0NiMjBNVXF3SkJBSUZVaWJsczNJWnFzcGM2M0lGWHdoZ1pNSlJORE83d3F4OXFJR1pUaGFwSVVKWlYzTEZHU2JndUgrTDU2N1NVR04zYVd1S25zckNFeTRycGdTSWVkNGtDUUJ2a1IzZ1lyR2c2UHZSNDBBcElQNUpBRUdlWGowdlZMZ29UNnJhWmFucVdtVVVqenJxZ2hSVVlrMng1RVRValcyN08rallWK01teUZibFBWWmxjcm5FQ1FBSVhtZEwvdHZ0MjZDdjZhcVY1RjNsMGZaQlVYbUFoV0JwU1AwZWdmSHJTOGxHQkJaTVFSaWd1RUdQVGVqZFk1Z3lkaUVMOG9kOTQzSXRETitCVURUaz0=';